import React from 'react';
import ControlledForm from "../reusable/ControlledForm/ControlledForm";
import TextInput from "../reusable/ControlledForm/Inputs/TextInput";
import DefaultSubmissionZone from "../reusable/ControlledForm/Submissions/DefaultSubmissionZone";
import UnitInput from "../reusable/ControlledForm/Inputs/UnitInput";
import {currencyUnits, massUnits} from "../global/lists";
import {defaultIngredient} from "../global/defaults";
import {IngredientDataHandler} from "../logic/db/IngredientDataHandler";
import {formDataToIngredient, ingredientToFormData} from "../utils/parser/ingredientParser";
import {IngredientModel} from "../logic/models/IngredientModel";
import {useTranslation} from "react-i18next";

type IngredientFormProps = {
    mode: "edit" | "add",
    ingredient?: IngredientModel,
    onCancel?: () => void
}

export const IngredientsForm = (props: IngredientFormProps) => {
    console.log(props.ingredient)
    const {ingredient, onCancel, mode} = props
    const {t} = useTranslation("common")
    const massOptions = massUnits.map(unit => { return {value: unit, name: t((`units.mass.${unit}`))}})
    const currencyOptions = currencyUnits.map(unit => { return {value: unit, name: t(`units.price.${unit}`)}})

    const onSubmit = (event: any, formData: any) => {
        const ingredientSubmission = formDataToIngredient(formData)
        const nameChanged = mode === "edit" && ingredient?.ingredient.name !== ingredientSubmission.name
        event.preventDefault()
        const dataBaseAction = mode === "add" ? IngredientDataHandler.addIngredient : IngredientDataHandler.updateIngredient
        dataBaseAction(ingredientSubmission, nameChanged ? ingredient?.ingredient.name : undefined)
            .then()
            .catch(() => console.log("FAILURE!"))
    }

    return (
        <div className="ingredients-form-wrapper">
            <ControlledForm initialValues={ingredientToFormData(ingredient ? ingredient.ingredient : defaultIngredient)}
                            onSubmit={onSubmit}>
                <h3 className="modal-title">{t(mode === "add" ? 'add.add_ingredient' : 'edit.edit_ingredient')}</h3>
                <TextInput name={"name"} label={t("data.name")}/>
                <UnitInput numberName={"mass"} label={t("units.mass.mass")} unitName={"massUnit"} options={massOptions}/>
                <UnitInput numberName={"price"} label={t("units.price.price")} unitName={"priceUnit"} options={currencyOptions}/>
                <DefaultSubmissionZone submitText={t(mode === "add" ? "add.add" : "edit.edit")} cancelText={t('cancel')} onCancel={onCancel}/>
            </ControlledForm>
        </div>
    );
}

export default IngredientsForm;
